import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const apiCalls = {};

apiCalls.fetchPermissions = async user_id => {

    const { data } = await api.get(`/users/${user_id}/permissions`);

    return data;
};

apiCalls.fetchUsers = async () => {

    const { data } = await api.get('/users');

    return data;
};

apiCalls.deleteUser = async userId => {

    const { data } = await api.delete(`/users/${userId}`);

    return data;
};

apiCalls.updateUser = async payload => {

    const { data } = await api.put(`/users/${payload.id}`, payload);

    return data;
};

apiCalls.createUser = async payload => {

    const { data } = await api.post('/users', payload);

    return data;
};


export const useFetchPermissions = (user_id, queryOptions = {}) => useQuery(['permissions', user_id], () => apiCalls.fetchPermissions(user_id), queryOptions);
export const useUsers = (queryOptions = {}) => useQuery('users', () => apiCalls.fetchUsers(), queryOptions);


export const useDeleteUser = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(userId => apiCalls.deleteUser(userId), {
        onSuccess: () => {
            queryClient.invalidateQueries('users');
        },
        ...queryOptions
    });
};

export const useUpdateUser = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.updateUser(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('users');
        },
        ...queryOptions
    });
};

export const useCreateUser = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.createUser(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('users');
        },
        ...queryOptions
    });
};
